// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningRequestSearchResponse } from './financialScreeningRequestSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': FinancialScreeningRequestSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "FinancialScreeningRequestSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningV1FinancialScreeningV1FinancialScreeningRequestSearchDefaultResponse.attributeTypeMap;
    }
}
